// import { lazy } from 'react';
import LogIn from '../Authentication/components/LogIn';
import LogOut from '../Authentication/components/LogOut';
import Unauthorized from './views/Unauthorized';
import AdminDashboard from "../AdminDashboard/AdminDashboard";
import StudentDashboard from "../StudentDashboard";
import RoleBasedRedirect from './components/RoleBasedRedirect';

const srOnlySx = {
  position: 'absolute',
  width: '1px',
  height: '1px',
  padding: 0,
  margin: '-1px',
  overflow: 'hidden',
  clip: `rect(0, 0, 0, 0)`,
  whiteSpace: 'nowrap',
  border: 0
}

const customHeading = {
    color: 'primary.main',
    fontSize: 'subtitle1.fontSize', //including in case you want to bring the title in. change subtitl1 to correct vairant.
    fontWeight: 'bold',
    mb: 2
}

const PATHS = [
    {
        path: "/",
        title: "Home",
        titleProps: {
            sx: srOnlySx
        },
        Component: RoleBasedRedirect,
    },
    {
        path: "/dashboard",
        title: "Student Dashboard",
        titleProps: {
            sx: srOnlySx
        },
        Component: StudentDashboard,
        authRequired: true
    },
    {
        path: "/admin/dashboard",
        title: "Admin Dashboard",
        Component: AdminDashboard,
        requiresAdminAccess: true,
        authRequired: true,
        titleProps: {
            sx: srOnlySx
        },
        noIndex: true
    },
];

export const authorizationRoutes = {
    login: "/login",
    logout: "/logout",
    unauthorized: "/unauthorized",
};

const authenticationFlowPaths = [
    {
        path: authorizationRoutes.login,
        title: "Log In",
        Component: LogIn
    },
    {
        path: authorizationRoutes.logout,
        title: "Log Out",
        Component: LogOut
    },
    {
        path: authorizationRoutes.unauthorized,
        title: "Not authorized",
        Component: Unauthorized
    }
]

export {
    authenticationFlowPaths,
    PATHS as default
}